export default "/Resources/dc985e0c532f5ef5245d477ec4ab64fa.svg";